import { MAX_ENTRIES_FOR_TREATMENT_TABLES } from '@components/app/TreatmentPage/consts'
import { Table } from '@components/primitives/Chart/Table'
import Input from '@components/primitives/Input'
import { Text } from '@components/primitives/Text'
import { faSearch } from '@fortawesome/pro-regular-svg-icons/faSearch'
import type { DrugInteraction } from '@modules/drugs/helpers/getTreatmentPageData'
import { useState } from 'react'

export const TreatmentDrugInteractions = ({
  drugInteractions,
  drugName,
}: {
  drugInteractions: DrugInteraction[]
  drugName: string
}) => {
  const [searchTerm, setSearchTerm] = useState('')

  const naiveSearch = (drugInteraction: DrugInteraction) => {
    return (
      drugInteraction.drugName +
      drugInteraction.interactionDescription +
      drugInteraction.interactionType +
      drugInteraction.riskLevel
    )
      .toLowerCase()
      .includes(searchTerm.toLowerCase().trim())
  }

  const interactionRowsToRender = drugInteractions
    .filter(naiveSearch)
    .slice(0, MAX_ENTRIES_FOR_TREATMENT_TABLES)
    .map((item) => [item.drugName, item.riskLevel, item.interactionDescription])

  if (!drugInteractions) {
    return null
  }

  return (
    <div className='my-8'>
      <div className='mb-8 flex justify-between'>
        <Text
          className='my-4'
          styleName={'h5'}
          value={`Common ${drugName} Drug Interactions`}
        />
        <Input
          icon={faSearch}
          onChange={(e) => setSearchTerm(e.target.value)}
          value={searchTerm}
        />
      </div>
      {/* TODO - join them */}
      <Table
        borderClass='border-neutral100'
        headerBackground='bg-neutral50'
        headerRow={['Drug Name', 'Risk Level', 'Description']}
        rows={interactionRowsToRender}
        textAlignment='text-left'
        textColor='text-neutral500'
      />
    </div>
  )
}
